import { AccountFacade } from '@amwager/account/data-access';
import {
  CountdownPipe,
  GetEventStatusPipe,
  GetRaceStatusPipe,
  SortEventsPipe
} from '@amwager/util';
import {
  IAccountPreferencesModel,
  IGetAccountPreferencesResponse,
  IGetEventsDetailsResponse
} from '@amwager/util-ts';
import { WagerFacade } from '@amwager/wager/data-access';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonTitle,
  IonToolbar,
  ModalController
} from '@ionic/angular/standalone';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'feature-ion-event-track-list',
  templateUrl: './event-track-list.component.html',
  styleUrls: ['./event-track-list.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    IonLabel,
    IonItem,
    IonList,
    SortEventsPipe,
    GetRaceStatusPipe,
    CountdownPipe,
    GetEventStatusPipe,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    IonIcon,
    IonTitle,
    IonContent
  ]
})
export class EventTrackListComponent { // not used
  events!: IGetEventsDetailsResponse[];
  sortBy: string = 'MTP';
  eventTypeFilter: string[] = [
    'Thoroughbred',
    'Quarterhorse',
    'Greyhound',
    'Harness',
    'International'
  ];

  constructor(
    private readonly wagerFacade: WagerFacade,
    private readonly accountFacade: AccountFacade,
    private readonly modalCtrl: ModalController,
    private readonly cdRef: ChangeDetectorRef
  ) {

    this.wagerFacade.getSelectAllEventTrackRace$()
      .subscribe((allEventTrackRace: IGetEventsDetailsResponse[]) => {
        // console.log('EventTrackListComponent:allEventTrackRace:', allEventTrackRace)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.events = allEventTrackRace as any;
      });

    this.accountFacade.isGetAccountPreferencesSuccess$()
      .subscribe((callback) => {
        // console.log(callback);
        if (callback?.isSuccess === undefined) return;

        const response: IAccountPreferencesModel = callback?.response?.AccountPreferences;
        this.sortBy = response?.SortBy || 'MTP';
        this.eventTypeFilter = response?.EventTypeFilter || [];
        this.cdRef.markForCheck();
      });
  }

  /**
   *
   * Modals
   */
    cancel() {
      return this.modalCtrl.dismiss(null, 'cancel');
    }

    close() {
      // return this.modalCtrl.dismiss(this.name, 'confirm');
      return this.modalCtrl.dismiss(null, 'cancel');
    }
}
